/* Darul Andlus product-page shelves (21 September 2026).
   <da-shelf>  arrows + edge state for a scroll-snap row (native swipe on touch).
   <da-recs>   fetches "People also bought" from /recommendations/products when scrolled near.
   <da-recent> keeps a small "recently viewed" list in localStorage and draws it.
   A book shown in an earlier shelf is dropped from later ones; a shelf below its minimum hides. */
(function () {
  'use strict';
  if (window.customElements === undefined || customElements.get('da-shelf')) return;

  function dedupe() {
    var seen = {};
    var shelves = Array.prototype.slice.call(document.querySelectorAll('.da-shelf'));
    shelves.sort(function (a, b) { return (a.dataset.dynamic ? 1 : 0) - (b.dataset.dynamic ? 1 : 0); });
    shelves.forEach(function (shelf) {
      if (shelf.closest('da-recent')) return;
      Array.prototype.forEach.call(shelf.querySelectorAll('.da-shelf__item'), function (item) {
        var h = item.dataset.handle;
        if (!h) return;
        if (seen[h]) item.remove(); else seen[h] = true;
      });
      var left = shelf.querySelectorAll('.da-shelf__item').length;
      if (left < (parseInt(shelf.dataset.min, 10) || 1)) shelf.hidden = true;
      var wrap = shelf.querySelector('da-shelf');
      if (wrap && wrap.update) wrap.update();
    });
  }

  var DaShelf = function () { return Reflect.construct(HTMLElement, [], DaShelf); };
  DaShelf.prototype = Object.create(HTMLElement.prototype);
  DaShelf.prototype.connectedCallback = function () {
    var self = this;
    this.track = this.querySelector('.da-shelf__track');
    if (!this.track) return;
    var prev = this.querySelector('.da-shelf__arrow--prev'), next = this.querySelector('.da-shelf__arrow--next');
    if (prev) prev.addEventListener('click', function () { self.go(-1); });
    if (next) next.addEventListener('click', function () { self.go(1); });
    this.track.addEventListener('scroll', function () { self.update(); }, { passive: true });
    window.addEventListener('resize', function () { self.update(); }, { passive: true });
    this.update();
  };
  DaShelf.prototype.go = function (dir) {
    this.track.scrollBy({ left: dir * this.track.clientWidth * 0.85, behavior: 'smooth' });
  };
  DaShelf.prototype.update = function () {
    var t = this.track; if (!t) return;
    var max = t.scrollWidth - t.clientWidth;
    this.classList.toggle('is-scrollable', max > 2);
    var prev = this.querySelector('.da-shelf__arrow--prev'), next = this.querySelector('.da-shelf__arrow--next');
    if (prev) prev.disabled = t.scrollLeft <= 1;
    if (next) next.disabled = t.scrollLeft >= max - 1;
  };
  customElements.define('da-shelf', DaShelf);

  var DaRecs = function () { return Reflect.construct(HTMLElement, [], DaRecs); };
  DaRecs.prototype = Object.create(HTMLElement.prototype);
  DaRecs.prototype.connectedCallback = function () {
    var self = this, url = this.dataset.url;
    if (!url || this.querySelector('.da-shelf__item')) return;
    var tries = 0;
    var load = function () {
      tries++;
      fetch(url).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('da-recs');
        if (!inner || !inner.querySelector('.da-shelf__item')) { self.remove(); return; }
        self.innerHTML = inner.innerHTML;
        dedupe();
      }).catch(function () {
        // Shopify kabhi kabhi 5xx de deta hai; ek baar aur koshish, phir chup chaap hat jao
        if (tries < 3) setTimeout(load, 1500 * tries); else self.remove();
      });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 900px 0px' });
      io.observe(this);
    } else load();
  };
  customElements.define('da-recs', DaRecs);

  var KEY = 'da_recent_v1';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { return '<span class="cvc-money">' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' PKR</span>'; }
  var SPINNER = '<div class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';
  function card(x) {
    var off = x.c > x.p && x.p > 0 ? Math.floor((x.c - x.p) * 100 / x.c) : 0;
    var img = x.i ? '<img class="da-card__img" src="' + esc(x.i) + '" alt="' + esc(x.t) + '" loading="lazy" width="480" height="640">' : '';
    var author = x.a ? '<p class="da-card__author">' + (x.au ? '<a href="' + esc(x.au) + '">' + esc(x.a) + '</a>' : esc(x.a)) + '</p>' : '';
    var btn;
    if (x.m) btn = '<a class="da-card__btn" href="' + esc(x.u) + '">Choose options</a>';
    else if (x.ok && x.v) btn = '<product-form><form method="post" action="/cart/add" class="form" data-type="add-to-cart-form" novalidate="novalidate"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="' + esc(x.v) + '" class="product-variant-id"><button type="submit" name="add" class="da-card__btn" aria-haspopup="dialog" aria-live="polite" data-sold-out-message="true"><span>Add to cart</span><span class="sold-out-message hidden">Sold out</span>' + SPINNER + '</button></form></product-form>';
    else btn = '<span class="da-card__btn da-card__btn--off">Sold out</span>';
    return '<li class="da-shelf__item" data-handle="' + esc(x.h) + '"><article class="da-card">' +
      '<a class="da-card__media" href="' + esc(x.u) + '" tabindex="-1" aria-hidden="true">' + img + (off ? '<span class="da-card__badge">' + off + '% off</span>' : '') + '</a>' +
      '<h3 class="da-card__title"><a href="' + esc(x.u) + '">' + esc(x.t) + '</a></h3>' + author +
      '<p class="da-card__price">' + (off ? '<s>' + money(x.c) + '</s> ' : '') + '<strong>' + money(x.p) + '</strong></p><div class="da-card__action">' + btn + '</div></article></li>';
  }

  var DaRecent = function () { return Reflect.construct(HTMLElement, [], DaRecent); };
  DaRecent.prototype = Object.create(HTMLElement.prototype);
  DaRecent.prototype.connectedCallback = function () {
    var self = this, list = [], cur = null;
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];
    try { var el = document.getElementById('da-recent-current'); if (el) cur = JSON.parse(el.textContent); } catch (e) { cur = null; }
    var max = parseInt(this.dataset.max, 10) || 12;
    var others = list.filter(function (x) { return x && x.h && (!cur || x.h !== cur.h); });
    if (cur && cur.h) {
      cur.ts = Date.now();
      try { localStorage.setItem(KEY, JSON.stringify([cur].concat(others).slice(0, 16))); } catch (e) { /* private mode */ }
    }
    others = others.slice(0, max);
    if (!others.length) return;
    var track = this.querySelector('.da-shelf__track');
    if (!track) return;
    track.innerHTML = others.map(card).join('');
    this.hidden = false;
    var clear = this.querySelector('.da-shelf__clear');
    if (clear) clear.addEventListener('click', function () {
      try { localStorage.removeItem(KEY); } catch (e) { /* ignore */ }
      self.hidden = true;
    });
    var wrap = this.querySelector('da-shelf');
    if (wrap && wrap.update) wrap.update();
  };
  customElements.define('da-recent', DaRecent);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dedupe); else dedupe();
})();
